// createRouter用来创建路由对象, createWebHistory,createWebHashHistory用来指定路由模式
import { createRouter, createWebHistory } from "vue-router";
// import Layout from "@/layout";
// 路由数组
const routes = [
  {
    path: "/", //如果是根路径就重定向到login页面
    redirect: "index",
  },
  {
    path: "/index",
    component: () => import("../views/index.vue"),
  }, {
    path: "/customerCase",
    component: () => import("../views/customerCase/index.vue"),
  }, {
    path: "/aboutUs",
    component: () => import("../views/aboutUs/index.vue"),
  }, {
    path: "/platform",
    component: () => import("../views/platform/index.vue"),
  }, {
    path: "/smartFactory",//智慧工厂数字孪生管理平台
    component: () => import("../views/platform/smartFactory.vue"),
    hidden: true
  }, {
    path: "/chemical",//化工园区智慧化管理平台
    component: () => import("../views/platform/chemical.vue"),
    hidden: true
  }, {
    path: "/futureComity",//未来社区综合管理平台
    component: () => import("../views/platform/futureComity.vue"),
    hidden: true
  },{
    path: "/energy",//能耗监测系统
    component: () => import("../views/platform/energy.vue"),
    hidden: true
  }, {
    path: "/surveying",//测绘/建模/数字孪生交互
    component: () => import("../views/platform/surveying.vue"),
    hidden: true
  }, {
    path: "/hardware",//智能硬件
    component: () => import("../views/platform/hardware.vue"),
    hidden: true
  }, {
    path: "/countryside",//智慧乡村
    component: () => import("../views/platform/index.vue"),
    hidden: true
  },{
    path: "/intelligentHardware",//智慧乡村
    component: () => import("../views/platform/intelligentHardware.vue"),
    hidden: true
  },{
    path: "/customerDetail",//客户案例详情
    component: () => import("../views/customerCase/detail.vue"),
    hidden: true
  },
  {
    path: "/newHardware",//智能硬件
    component: () => import("../views/hardware/intelligentHardware.vue"),
    hidden: true
  }
];
// 创建路由对象
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
